import { OnboardingProfilesList } from "./ProfilesList";

export const pages = {
  "profiles-list": OnboardingProfilesList,
};
